import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./rootReducer";
import type { RootState } from "@/types";

const store = configureStore({
    reducer: {
        ...rootReducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
});

export type AppDispatch = typeof store.dispatch;
export type { RootState };

export default store;
